"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var link_exports = {};
__export(link_exports, {
  LinkExtension: () => LinkExtension,
  shouldAutoLink: () => shouldAutoLink
});
module.exports = __toCommonJS(link_exports);
var import_core = require("@tiptap/core");
var import_tiptapExtensions = require("../tiptapExtensions");
function shouldAutoLink(text) {
  const value = text.trim();
  return /^[a-z][a-z\d+.-]*:/i.test(value) || /^www\./i.test(value) || value.includes("@");
}
__name(shouldAutoLink, "shouldAutoLink");
const LinkExtension = import_tiptapExtensions.Link.extend({
  inclusive: false,
  addPasteRules() {
    return (this.parent?.() ?? []).map((rule) => {
      const find = rule.find;
      if (find instanceof RegExp) return rule;
      return new import_core.PasteRule({
        find: /* @__PURE__ */ __name((text, event) => find(text, event)?.filter((match) => shouldAutoLink(match.text)), "find"),
        handler: rule.handler
      });
    });
  }
});
//# sourceMappingURL=link.js.map
